import { render, staticRenderFns } from "./MenuRightIcon.vue?vue&type=template&id=46aaa24c&scoped=true"
import script from "./MenuRightIcon.vue?vue&type=script&lang=js"
export * from "./MenuRightIcon.vue?vue&type=script&lang=js"
import style0 from "./MenuRightIcon.vue?vue&type=style&index=0&id=46aaa24c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aaa24c",
  null
  
)

export default component.exports